// Vtravel Landing Page Mock Data - Refined Version

export const heroData = {
  headline: "Your Journey is our Business",
  subheadline: "Sea the World Differently...",
  ctaPrimary: "Message Your Consultant",
  ctaSecondary: "Plan Your Trip",
  slides: [
    {
      image: "https://images.unsplash.com/photo-1554254648-2d58a1bc3fd5?w=1920&q=80",
      alt: "Luxury cruise ship at sunset"
    },
    {
      image: "https://images.unsplash.com/photo-1609412058473-c199497c3c5d?w=1920&q=80",
      alt: "Vietnam rice terraces at sunrise"
    },
    {
      image: "https://images.unsplash.com/photo-1587595431973-160d0d94add1?w=1920&q=80",
      alt: "Machu Picchu ancient ruins Peru"
    },
    {
      image: "https://images.unsplash.com/photo-1551918120-9739cb430c6d?w=1920&q=80",
      alt: "Luxury infinity pool resort"
    },
    {
      image: "https://images.unsplash.com/photo-1594069758873-e79e9075eb7d?w=1920&q=80",
      alt: "Alpine mountain village"
    },
    {
      image: "https://images.unsplash.com/photo-1548710332-3e03e8220a79?w=1920&q=80",
      alt: "Dramatic rice terrace landscape Asia"
    },
    {
      image: "https://images.unsplash.com/photo-1664387518989-bb1d8574f078?w=1920&q=80",
      alt: "Machu Picchu with llamas South America"
    }
  ]
};

export const aboutData = {
  tagline: "The Vtravel Difference",
  title: "Where Personal Service Meets Industry Professionalism",
  description: "Vtravel is more than a consultancy — it's 25 years in the making, built entirely on repeat business and referrals from satisfied clients. We are committed to planning your journey from start to finish and delivering the best value for money, no matter your budget.",
  extendedDescription: [
    "From our discerning Business and First Class travellers to our loyal point-to-point clients, we value and appreciate every individual who trusts us with their travel. Every itinerary is crafted with care — whether it's gorilla trekking in Rwanda, a Celebrity Cruises voyage, or a self-drive through Namibia.",
    "We are not afraid of scale: we've coordinated Church tours to Israel, managed a Paradis Beachcomber wedding, and handled an entire group from the United States to celebrate a bespoke 25th-anniversary event in the Winelands.",
    "Our motto is simple: \"Variety is the spice of life.\" Bring us your unique journey to plan — it's our business, and it's our pleasure."
  ],
  values: [
    {
      title: "Bespoke Planning",
      description: "We cover the globe and tailor-make your trip to suit your needs"
    },
    {
      title: "Direct Access",
      description: "A personal travel consultant is available 24/7 for your convenience"
    },
    {
      title: "Exclusive Rates",
      description: "We have sourced highly competitive land and air pricing from our suppliers"
    },
    {
      title: "All Things Travel",
      description: "We handle hotels, visas, rail journeys, flights, cruises and more"
    }
  ]
};

export const accoladesData = {
  tagline: "Recognition & Excellence",
  title: "Award-Winning Service",
  awards: [
    {
      id: 1,
      title: "Club Travel Group",
      subtitle: "Top 20 Travel Agents",
      year: "2024"
    },
    {
      id: 2,
      title: "Flight Centre",
      subtitle: "Million Dollar Consultant",
      year: "2000"
    },
    {
      id: 3,
      title: "ABSA Jewish Achievers",
      subtitle: "Global Woman in Leadership",
      year: "2021"
    },
    {
      id: 4,
      title: "Best Thing Ever",
      subtitle: "FB Group Top 3 Travel Agents",
      year: "2025"
    },
    {
      id: 5,
      title: "OrtJet Shining Light Awards",
      subtitle: "2nd Place Winner – Covid",
      year: "2020"
    }
  ]
};

export const servicesData = [
  {
    id: "flights",
    title: "Flights & Airline Tickets",
    description: "Premium routes and fares for effortless travel. Business class, first class—air travel as it should be.",
    image: "https://images.unsplash.com/photo-1661954864180-e61dea14208a?w=800&q=80",
    features: ["Premium Economy", "Business Class", "First Class"]
  },
  {
    id: "cruises",
    title: "Cruise Packages",
    description: "Curated voyages across the Mediterranean, Caribbean, and beyond. From Celebrity to Azamara, Royal Caribbean to Regent of the Seas. Your perfect escape awaits.",
    image: "https://images.unsplash.com/photo-1722914873924-cf64eafb6175?w=800&q=80",
    features: ["Mediterranean", "Caribbean", "European Rivers"]
  },
  {
    id: "hotels",
    title: "Hotels & Resorts",
    description: "From boutique hideaways to grand luxury resorts. The perfect stay, every time.",
    image: "https://images.unsplash.com/photo-1700219447843-d9fafce8143f?w=800&q=80",
    features: ["Luxury Resorts", "Boutique Hotels", "Private Villas"]
  },
  {
    id: "itineraries",
    title: "Custom Itineraries",
    description: "From Japan to Croatia, China to Egypt – crafted to perfection.",
    image: "https://images.unsplash.com/photo-1551918120-9739cb430c6d?w=800&q=80",
    features: ["Europe", "Islands", "Middle East"]
  }
];

export const testimonialsData = [
  {
    id: 1,
    name: "Sid Gupta",
    location: "Dubai, UAE",
    text: "Thank you Vanessa, you are THE BEST! I cannot thank you enough for the incredible support you extended to us during the crisis. Your swift action made all the difference.",
    rating: 5,
    tripType: "Middle East Crisis 2026"
  },
  {
    id: 2,
    name: "Melissa Chan",
    location: "Abu Dhabi to Bangkok",
    text: "Your amazing professional and efficient service was mind-blowing. The way you jumped in and found flights immediately, while showing such compassion during a stressful situation escaping a war zone — truly exceptional.",
    rating: 5,
    tripType: "Middle East Crisis 2026"
  },
  {
    id: 3,
    name: "Linda Binder",
    location: "Cape Town to London",
    text: "After 4 years waiting to visit my daughter in London, flight disruptions left me stranded. I messaged Vanessa on a Sunday — within moments she called back, so kind and calm, and rebooked me within minutes! Invaluable SOS service.",
    rating: 5,
    tripType: "Middle East Crisis 2026"
  },
  {
    id: 4,
    name: "Sune Van Zyl",
    location: "Australia",
    text: "Thank you, you gave us our life back. So many people think the absolute world of you and speak highly of you. You've helped an incredible amount of people!",
    rating: 5,
    tripType: "Covid Repatriation"
  },
  {
    id: 5,
    name: "Cheryllynn Hiles Brown",
    location: "Australia",
    text: "We'll never forget December 2021 when you managed to fly Damon halfway around the world so he could get back to Australia in time to take his scholarship.",
    rating: 5,
    tripType: "Scholarship Travel"
  },
  {
    id: 6,
    name: "Chantal Thomas Souter",
    location: "South Africa",
    text: "You really are the BEST! Always going above and beyond!",
    rating: 5,
    tripType: "Industry Recognition"
  },
  {
    id: 7,
    name: "Garth Jordan",
    location: "Cambodia",
    text: "Can personally vouch for Vanessa. She was up early hours of the morning getting me back from Cambodia. Vanessa went way beyond what any other travel agent would do. Will always make use of her flight whisperer skills.",
    rating: 5,
    tripType: "Emergency Repatriation"
  },
  {
    id: 8,
    name: "Rachmah Falal Emeran",
    location: "Australia",
    text: "I completely trust and recommend Vanessa to all my friends and family. Effortless and transparent. My mother has visited me twice, always books with Vanessa who gets her visas granted in record time.",
    rating: 5,
    tripType: "Visa Assistance"
  },
  {
    id: 9,
    name: "Marinda Delport",
    location: "Australia",
    text: "I have used Vanessa 3 times now and am extremely happy with the amount of trouble she goes through to make sure everything is well and sorted out.",
    rating: 5,
    tripType: "Repeat Client"
  },
  {
    id: 10,
    name: "Lynn Koning",
    location: "Australia",
    text: "We used Vanessa many times especially during Covid, she was a true lifesaver.",
    rating: 5,
    tripType: "Covid Travel Support"
  },
  {
    id: 11,
    name: "Dawn Heath",
    location: "South Africa",
    text: "I have never met Vanessa in person but I found her very friendly and efficient with email contact and calls. Nothing is too much trouble and she has always gone the extra mile for me.",
    rating: 5,
    tripType: "Virtual Client"
  },
  {
    id: 9,
    name: "Scharita Ann Conradie Joubert",
    location: "South Africa",
    text: "Vanessa helped me in 2022 and trust me, I have not forgotten the high level of service we received. You are 1 in a million Vanessa.",
    rating: 5,
    tripType: "Premium Service"
  },
  {
    id: 10,
    name: "Cindi Onia",
    location: "Namibia",
    text: "Vanessa is a true travel angel! When my self-drive was on the brink of disaster with a local agent, Vanessa stepped in and saved the day. With her expertise, guidance and exceptional work ethic she transformed my nightmare into a dream come true.",
    rating: 5,
    tripType: "Self-Drive Safari"
  },
  {
    id: 11,
    name: "Eric Miller",
    location: "Albania",
    text: "Special thanks to Vanessa for facilitating my Albania visa when other agents couldn't get it done.",
    rating: 5,
    tripType: "Visa Assistance"
  },
  {
    id: 12,
    name: "Catherine Greaves",
    location: "Australia",
    text: "Thank you for arranging our flights – I didn't even have to check new seats, they were perfect. You're the best!",
    rating: 5,
    tripType: "Flight Booking"
  },
  {
    id: 13,
    name: "Karlien Bosman",
    location: "Cruise",
    text: "We can't thank Vtravel enough for saving our trip, and her selfless effort to help us after a terrible experience with another agency. Vanessa has gone above and beyond to help our family realize our holiday dream.",
    rating: 5,
    tripType: "Cruise Rescue"
  },
  {
    id: 14,
    name: "Patiwe",
    location: "Australia",
    text: "It is with great joy to let you know that mum's visa has been granted. Thank you for your amazing work!",
    rating: 5,
    tripType: "Visa Approval"
  },
  {
    id: 15,
    name: "Tracy-Lee",
    location: "South Africa",
    text: "Thank you so much for your help. I'm forever grateful for your service. God bless.",
    rating: 5,
    tripType: "Travel Assistance"
  },
  {
    id: 16,
    name: "Piveshnie Govender",
    location: "Qatar",
    text: "Thank you for such amazing service and my toddler was so comfortable during the flight!",
    rating: 5,
    tripType: "Business Class"
  },
  {
    id: 17,
    name: "Cindy-Lee Pretorious",
    location: "Australia",
    text: "Big shout out and huge thanks to Vanessa for your assistance and level of professionalism to help us get from Port Elizabeth to Bundaberg.",
    rating: 5,
    tripType: "Emergency Travel"
  },
  {
    id: 18,
    name: "Madeleine Oberholzer",
    location: "South Africa",
    text: "The most amazing service from this woman!",
    rating: 5,
    tripType: "Outstanding Service"
  },
  {
    id: 19,
    name: "Cassi Lee Rubin",
    location: "Rwanda",
    text: "This hotel is just BEYOND! Words cannot describe… magical… thank you Vanessa.",
    rating: 5,
    tripType: "Gorilla Trekking"
  }
];

export const contactData = {
  headline: "Begin Your Journey",
  subheadline: "Speak directly with your personal travel consultant.",
  description: "Flights, cruises, hotels, holiday packages—designed for you.",
  whatsapp: "+27 69 953 4705",
  email: "vanessa@vtravel.co.za"
};

export const navigationData = {
  logo: "Vtravel",
  links: [
    { label: "About", href: "#about" },
    { label: "Services", href: "#services" },
    { label: "Testimonials", href: "#testimonials" },
    { label: "Contact", href: "#contact" }
  ]
};

export const footerData = {
  logo: "Vtravel",
  copyright: `© ${new Date().getFullYear()} Vtravel. All rights reserved.`,
  links: [
    { label: "Privacy", href: "#" },
    { label: "Terms", href: "#" }
  ]
};
